import { useMemo } from 'react'
import type { BlocksContent } from '@strapi/blocks-react-renderer'

import { RichTextProps } from '../../components/RichText'

import { transformRichText } from './transformRichText'

export const useRichText = (
  text?: string | any[] | null
): RichTextProps | undefined => {
  return useMemo(() => {
    if (Array.isArray(text)) {
      return { blocks: text as BlocksContent }
    }
    return {
      data: transformRichText(text),
    }
  }, [text])
}
